import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  padding: ${theme.unit * 2}px;
  background: white;
  border-radius: ${theme.unit}px;
`);



// WEBPACK FOOTER //
// ./src/components/blocks/FormBlock.js